module.exports = __webpack_public_path__ + "static/media/logomarca.790ef129.png";